<app-card
  [cardBodyClasses]="'card-summary-info__body'"
  [cardClasses]="'border border-gray-300 h-100 mb-0'"
>
  <ng-container cardBody>
    <app-skeleton-text [height]="25" [isLoading]="isLoading" [width]="labelSkeletonWidth">
      <h3 class="card-summary-info__label mb-0 text-gray-700 me-2">
        {{ label }}
        <span
          *ngIf="info"
          [inlineSVG]="STRING_CONSTANTS.ICON.IC_INFORMATION_GREY"
          [ngbPopover]="info"
          class="ms-2 cursor-pointer"
          container="body"
          placement="bottom"
          popoverClass="tooltip-info"
          triggers="mouseenter:mouseleave"
        ></span>
      </h3>
    </app-skeleton-text>

    <app-skeleton-text [height]="25" [isLoading]="isLoading" [width]="valueSkeletonWidth">
      <h1 class="card-summary-info__value fw-bold m-0">{{ value || '-' }}</h1>
    </app-skeleton-text>
  </ng-container>
</app-card>
